import * as Yup from "yup";

const validationSchema = Yup.object({
  image: Yup.object().required("Image is required."),
  name: Yup.string().required("Category Name is required."),
  code: Yup.string().required("Category Code is required."),
  description: Yup.string().required("Description is required."),
});

export { validationSchema };
